export const environment = {
  production: true,
  env: 'qa'
};
